export default __webpack_public_path__ + "static/Integrations-b152a49a7fb05b4240154dbd56bdfd80.mp4";